import { Fragment } from 'react'

import { Tooltip, TooltipPosition } from '@loadsmart/loadsmart-ui'
import { Tag } from '@loadsmart/miranda-react'

import { type Stop } from '../../../domain/Stop'
import { plural } from '../../../utils/string'
import { Information } from '../information/Information'

export type ExtraStopInformationProps = {
  stops: Array<Stop>
  titleFormatter: (stop: Stop) => string
  subTitleFormatter?: (stop: Stop) => string | undefined
}

export function ExtraStopInformation({
  stops,
  titleFormatter,
  subTitleFormatter,
}: ExtraStopInformationProps) {
  const length = stops.length
  const lastIndex = length - 1
  const hasMoreThanOneItem = length > 1

  if (length === 0) {
    return null
  }

  return (
    <Tooltip
      position={TooltipPosition.Bottom}
      message={stops.map((stop, index) => {
        const isLast = index === lastIndex
        const shouldRenderSeparator = !isLast && hasMoreThanOneItem
        const value = titleFormatter(stop)
        const extra = subTitleFormatter?.(stop)

        return (
          <Fragment key={`extra-stop-${stop.city}-${stop.state}`}>
            <Information title={value} subTitle={extra} inverted />
            {shouldRenderSeparator && <hr />}
          </Fragment>
        )
      })}
    >
      <Tag variant="neutral">{`+${length} ${plural('stop', length)}`}</Tag>
    </Tooltip>
  )
}
